import React from 'react';

const Cont = ({ children, classes, spacing = 'p-12pt md:p-24pt' }) => (
  <div
    className={`bg-background-quaternary border border-border-darker-yellow rounded-lg ${spacing} ${classes}`}
  >
    {children}
  </div>
);

export default Cont;
